import React, {useContext, useEffect, useState } from "react";
import { ManageApis } from "../../AppServices/ManageApi";
import DataTable from "../../Components/DataTable/DataTable";
import { globalContext } from "../../App";
import FilterComponent from "../../Components/FilterComponent/FilterComponent";
import {
  lengthValidation1,
  preventSpecialCharsandNum,
  sanitizePhoneNumber2,
  validateLength,
} from "../../Common/Utils/Utils";
import { AlertinitialValue } from "../../Common/Utils/intialValues";
import AlertBox from "../../Components/AlertBox/AlertBox";
import { Button } from "react-bootstrap";
function Customers() {
  const [TableData, setTableData] = useState([]);
  const [TotalCount, setTotalCount] = useState();
  const [pageSize, setpageSize] = useState(10);
  const [currentPage, setcurrentPage] = useState(1);
  const [filterData, setFilterData] = useState({
    agentId: "",
    custName: "",
    custPhone: "",
    uniqueId: "",
  });
  const [errorMsg, setErrorMsg] = useState({});
  const { setIsLoader, userPermissions } = useContext(globalContext);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [filter, setFilter] = useState(false);
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  const [isPermitted, setIsPermitted] = useState(AlertinitialValue);
  const columns = [
    {
      title: "Sl No",
      dataIndex: "key",
    },
    {
      title: "Unique ID",
      dataIndex: "uniqueId",
    },
    {
      title: "DC Agent ID",
      dataIndex: "agentId",
    },
    {
      title: "Customer Name",
      dataIndex: "custName",
    },

    {
      title: "Customer Phone No.",
      dataIndex: "custPhone",
    },
    {
      title: "Customer Address",
      dataIndex: "custAddress",
    },
    ...(!isPermitted
      ? []
      : [
          {
            title: "Sync Customer Chitty",
            dataIndex: "action",
            render: (_, record, index) => (
              <Button
                className="btn button1 text_master border-0 px-4 py-0 rounded-pill font_500 shadow_sm_4 font_14  px-4"
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "rgba(29, 59, 109, 0.10)",
                }}
                onClick={() => handleSyncChitties(record)}
              >
                Sync
              </Button>
            ),
            headerCellStyle: {
              minWidth: '110px',
            },
          },
        ]),
  ];

  const filterListData = [
    {
      type: "text",
      placeholder: "Customer Name",
      name: "custName",
    },
    {
      type: "text",
      placeholder: "DC Agent ID",
      name: "agentId",
    },
    {
      type: "text",
      placeholder: "Unique ID",
      name: "uniqueId",
    },
    // {
    //   type: "text",
    //   placeholder: "Customer contact number",
    //   name: "mobileNo",
    // },
  ];

  useEffect(() => {
    fetchTableDatas();
  }, [pageSize,currentPage]);

  useEffect(() => {
    const UpdatePermission = userPermissions.some(
      permission => permission.label === 'CustomerChittySync'
    );
  
    setIsPermitted(UpdatePermission);
  }, [userPermissions]);

  useEffect(() => {
    if (isFilterReset) {
      setFilter(false);
      setIsFilterReset(false);
    }
  }, [isFilterReset]);

  const handleFilterReset = () => {
    setFilterData({
      agentId: "",
      custName: "",
      custPhone: "",
      uniqueId: "",
    });
    setErrorMsg({});
    setIsFilterReset(true);
  };

  const handleOnChange = (value, label, index, name) => {
    let updatedValue = value;
    setErrorMsg((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (!value || value === "") {
      updatedValue = "";
    }
    switch (name) {
      case "custName":
        updatedValue = preventSpecialCharsandNum(validateLength(value, 30));
        setErrorMsg((prev) => ({
          ...prev,
          [name]: lengthValidation1(updatedValue, 3),
        }));
        break;

      case "agentId":
      case "uniqueId":
        updatedValue = sanitizePhoneNumber2(
          validateLength(value, name === "ChittalNo" ? 5 : 15)
        );
        break;
      case "mobileNo":
        updatedValue = sanitizePhoneNumber2(validateLength(value, 10));
        setErrorMsg((pre) => ({
          ...pre,
          [name]: lengthValidation1(value, 10),
        }));
        break;
      default:
        break;
    }
    setFilterData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  const handleSyncChitties = async (record) => {
    try {
      setIsLoader(true)
      if (!record) return;
      let path = global.customerSync;
      let reqBody = {
        customerId: record?.uniqueId,
      };
      const responses = await ManageApis("post", path, reqBody);
      if (responses.response_data.status) {
        setShowAlert({
          show: true,
          type: "",
          message: responses.response_data.message,
          isSuccess: true,
        });
      } else {
        setShowAlert({
          show: true,
          type: "",
          message: responses.response_data.message,
          isFalse: true,
        });
      }
    } catch (error) {
      console.log(error);
    }finally{
      setIsLoader(false)
    }
  };

  const fetchTableDatas = async (page) => {
    try {
      setIsLoader(true);
      let path;
      let reqstBody = {};
      let apiCalls = [];
      const agentIdValue = filterData?.agentId;
      const customerNameValue = filterData?.custName;
      const uniqueId = filterData?.uniqueId;
      const phoneNoValue = filterData?.custPhone;
      if (page) {
        setcurrentPage((prev) => page);
      }
      const startingIndex = (currentPage - 1) * pageSize + 1;
      let params = phoneNoValue ? `name=${phoneNoValue}&` : "";
      params = params + (agentIdValue ? `agentId=${agentIdValue}&` : "");
      params =
        params + (customerNameValue ? `customerName=${customerNameValue}&` : "");
      params = params + (uniqueId ? `uniqueId=${uniqueId}&` : "");
      path =
        global.customerList + `?${params}page=${currentPage}&limit=${pageSize}`;
      // reqstBody = {};

      apiCalls.push(commonApiCall({ path, reqstBody, method: "get" }));

      const responses = await Promise.all(apiCalls);

      responses.forEach(({ message, response_data }) => {
        if (message === "Success") {
          const { data } = response_data || {};
          setTableData(
            data.docs.map((itm, index) => ({
              ...itm,
              key: startingIndex + index,
            }))
          );
          setTotalCount(data.total);
          setpageSize(parseInt(data.limit));
        } else {
          // Handle error case if necessary
        }
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoader(false);
    }
  };

  async function commonApiCall({ path, reqstBody, method = "post" }) {
    if (!path) return;
    try {
      const result = await ManageApis(method, path, reqstBody);
      return result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  function onChangeTable(current, size) {
    setcurrentPage(current);
    setpageSize(parseInt(size));
  }

  return (
    <div>
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isFalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={() => setShowAlert(AlertinitialValue)}
        hideCloseBtn={showAlert.hideCloseBtn}
      />
      <div className="d-flex justify-content-between align-items-center">
        <div className="bg-white  position-relative headStyle1 shadow_sm_4 w_fit_content min_w_160x ps-4 pt-3 pb-2">
          <h2 className="mb-0 mt-0 text-start text_master font_16 font_500">
            Customers
          </h2>
          <div className="headStyle2 position-absolute"></div>
        </div>
        <FilterComponent
          filterInputData={filterListData}
          handleChange={handleOnChange}
          value={filterData}
          errorMsg={errorMsg}
          handleReset={handleFilterReset}
          handleApply={() => {
            fetchTableDatas(1);
            setFilter(true);
          }}
          resetEnabled={filter}
        />
      </div>
      <div className=" pb-3  custom_pagination expandable-table customise_table2 shadow_sm_4   ">
        <DataTable
          columns={columns}
          rowData={TableData}
          pageSize={pageSize}
          currentPage={currentPage}
          onChangeTable={(current, Size) => onChangeTable(current, Size)}
          scroll={TotalCount > 5 ? { y: 400 } : ""}
          total={TotalCount}
          setPageSize={setpageSize}
        />
      </div>
    </div>
  );
}

export default Customers;
